"use client"
import { LinkType, NavigationTypeOne } from "@/libs/types";
import clsx from "clsx";
import React from "react";
import LinkCustomized from "../../LinkCustomized";

interface ExtendedProps {
    locale: string
    navigation: NavigationTypeOne
}

const Extended: React.FC<ExtendedProps> = ({
    locale,
    navigation
}) => {

    const ref = React.useRef<any>();
    const wrapper = React.useRef<any>();

    const extendedMenuWrapperPosition = (ref.current?.offsetWidth - wrapper.current?.offsetWidth) / 2

    const [show, setShow] = React.useState<boolean>(false)

    const handleCloseWrapper = () => setShow(false)
    return (
        <>
            <div ref={ref} className={clsx("menu-dropdown my-auto", navigation?.classes)}
                onMouseOver={() => setShow(true)}
                onMouseLeave={handleCloseWrapper}>
                <span className="cursor-pointer">{navigation.name}</span>
                <div ref={wrapper}
                    className={clsx("menu-extended bg-white rounded-bottom p-3 pb-5", show ? "menu-toggle-on" : "")} id="Header:ui.Extended">
                    <div className="container" onMouseLeave={handleCloseWrapper}>
                        <div className="row menu-extended-wrapper">
                            {navigation.extended.map((item: any, index: number) => {
                                const menuLeft = item?.megamenu?.filter((menu: any) => menu.position === "left")
                                const menuRight = item?.megamenu?.filter((menu: any) => menu.position === "right")
                                return (
                                    <div className={clsx("col-12 col-md-4", item?.classes)} key={index}>
                                        <p className="fw-bold menu-sub-category-title text-primary">{item.name}</p>
                                        {item.items.length !== 0 && item.items.map((linked: LinkType) => {
                                            return (
                                                <LinkCustomized
                                                    key={linked.id}
                                                    locale={locale}
                                                    linked={linked}
                                                    className="d-flex"
                                                    clicker={handleCloseWrapper}
                                                >
                                                    {!!linked.featured && <div className="featured" />}
                                                </LinkCustomized>
                                            )
                                        })}
                                        <div className="row">
                                            {menuLeft && <div className="col-6">
                                                {menuLeft?.map((menu: any, i: number) => {
                                                    return (
                                                        <div key={i} className="menu-features">
                                                            <p className="fw-bold">{menu?.name}</p>
                                                            {menu?.extended?.length !== 0 && menu?.extended?.map((linked: LinkType) => {
                                                                return (
                                                                    <LinkCustomized
                                                                        key={linked.id}
                                                                        locale={locale}
                                                                        linked={linked}
                                                                        className="d-flex"
                                                                        clicker={handleCloseWrapper}
                                                                    />
                                                                )
                                                            })}
                                                        </div>
                                                    )
                                                })}
                                            </div>}
                                            {menuRight && <div className="col-6">
                                                {menuRight?.map((menu: any, i: number) => {
                                                    return (
                                                        <div key={i} className="menu-features">
                                                            <p className="fw-bold">{menu?.name}</p>
                                                            {menu?.extended?.length !== 0 && menu?.extended?.map((linked: any) => {
                                                                return (
                                                                    <LinkCustomized
                                                                        key={linked.id}
                                                                        locale={locale}
                                                                        linked={linked}
                                                                        className="d-flex"
                                                                        clicker={handleCloseWrapper}
                                                                    />
                                                                )
                                                            })}
                                                        </div>
                                                    )
                                                })}
                                            </div>}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .menu-extended {
                    --bs-menu-extended-width: 800px;
                    width: var(--bs-menu-extended-width);
                    left: ${extendedMenuWrapperPosition}px;
                }
            `}
            </style>
        </>
    )
}

export default Extended;